import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { RiRefreshLine } from "react-icons/ri";
import Select from 'react-select';
import LeaseApiService from '../../services/apiService';
import { IoSearch } from "react-icons/io5";
import WindowedSelect from 'react-windowed-select';
import Pagination from '../pagination/pagination';

const HistoryList = ({ historyFormData, setHistoryFormData, HistoryProperty, historyLeaseNos, historyList, setHistoryList }) => {
    const apiService = new LeaseApiService();
    const [unitRent, setUnitRent] = useState(true);
    const [unitList, setUnitList] = useState([])
    const [pageSize, setPageSize] = useState(20)
    const [pagination, setPagination] = useState()

    const handleClearFilters = () => {
        setHistoryFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
    }
    const handlePropertyChange = async (selectedOption) => {
        if (selectedOption?.label === "All") {
            setUnitList([{ value: 'All', text: 'All' }]);
            setHistoryFormData({
                ...historyFormData,
                Proprty: selectedOption,
                Proprty: [{ label: 'Select Property', value: '' }],
                unitNo: [{ label: 'Select Unit No', value: '' }],
            });
        } else {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'TeminationHistoryUnitNosByPropertyId');
            params.append('CascadValue', selectedOption?.value?.value);
            const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
            setUnitList([{ value: 'All', text: 'All' }, ...res?.data?.items]);
            setHistoryFormData({
                ...historyFormData, Proprty: selectedOption,
                Proprty: [{ label: 'Select Property', value: '' }],
                unitNo: [{ label: 'Select Unit No', value: '' }],
            });
        }
    }
    const handleUitNo = async (selectedOption) => {
        handleClearFilters()
        let selectedLease = historyLeaseNos.find((comp) => comp.value === selectedOption?.value?.value)
        setHistoryFormData({
            ...historyFormData,
            unitNo: selectedOption,
            leaseNo: { label: selectedLease?.value, value: selectedLease },
        });
    }
    const handleLeaseChange = (selectedOption) => {
        setHistoryFormData({
            ...historyFormData, leaseNo: selectedOption,
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
        });
    }
    const handleSearch = async () => {
        try {
            const params = new URLSearchParams();
            params.append('PropertyNo', historyFormData?.Proprty?.value?.value || "All");
            params.append('UnitNo', historyFormData?.unitNo?.value?.text || "All");
            params.append('Leaseno', historyFormData?.leaseNo?.label || "All");
            params.append('PageNo', 1);
            params.append('PageSize', 20);
            
            const res = await apiService.getApiParamater('TERMINATION_HISTORY_LIST', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            setHistoryList(res?.data?.result || [])
        } catch (error) {
            console.error('Error fetching  data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PropertyNo', historyFormData?.Proprty?.value?.value || "All");
            params.append('UnitNo', historyFormData?.unitNo?.value?.text || "All");
            params.append('Leaseno', historyFormData?.leaseNo?.label || "All");
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 20);
            const res = await apiService.getApiParamater('TERMINATION_HISTORY_LIST', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            setHistoryList(res?.data?.result || [])

        } catch (error) {
            console.error('Error fetching  data:', error);
        }
    }
    const columnDefs = [
        {
            headerName: 'Lease No', field: 'leaseNo', filter: true,
            floatingFilter: true, suppressMovable: true, width: 500
        },
        {
            headerName: 'Property Name', field: 'propertyName', filter: true,
            floatingFilter: true, suppressMovable: true, width: 500
        },
        {
            headerName: 'Unit No', field: 'unitNo', filter: true, floatingFilter: true, suppressMovable: true, width: 530
        }
    ]
    return (
        <div className=' mt-3'>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setUnitRent(!unitRent)}>
                    <div className='param-label pt-1'>Search</div>
                </div>
                <div className={`slide-content ${unitRent ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${unitRent ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                            <div className='d-flex'>
                                <Select
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={historyFormData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={HistoryProperty?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='d-flex'>
                                <Select
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={historyFormData.unitNo}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                    options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='d-flex'>
                                <WindowedSelect
                                    className="w-100  p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    options={
                                        historyLeaseNos
                                            ?.slice(0, 5000)
                                            .map(rec => ({ value: rec, label: rec?.value }))
                                    }
                                    value={historyFormData.leaseNo}
                                    onChange={(selectedOption) => handleLeaseChange(selectedOption)}
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <div className='mainbtnGry flex-end gap-2 w-50' onClick={handleSearch}>
                                    <IoSearch color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                                <div className='mainbtnRed flex-end gap-2 w-50' onClick={handleClearFilters}>
                                    <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridshad  mt-2'>
                <div className="ag-theme-quartz" style={{ height: 470 }}>
                    <AgGridReact
                        getRowStyle={(params) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: '#F0EDF5' };
                            } else {
                                return { background: '#fff' };
                            }
                        }}
                        rowData={historyList}
                        enableFilter={true}
                        floatingFilter={true}
                        columnDefs={columnDefs}
                    />
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
        </div>
    );
};

export default HistoryList;